import { SocialMediaGallery } from '@components/sections/SocialMediaGallery';

export function About() {
  return (
    <div className="mx-auto mt-8 bg-gradient-to-br from-sky-100 via-sky-50 to-white">
      {/* Social Media Gallery Section */}
      <SocialMediaGallery />
    </div>
  );
}